import { APIPayment } from 'types/api';

const CHECK_NUMBER_REGEX = /^\d+$/;

export const sanitizeCheckNumber = (value: string) => value.replace(/\D/g, '');

export const isValidCheckNumber = (value: string) =>
  CHECK_NUMBER_REGEX.test(value.trim());

export const mapPaymentToRequest = (payment?: APIPayment | null) => {
  if (!payment) {
    return {};
  }

  return {
    // Direct property mappings
    amount: payment.amount,
    checkNumber: payment.checkNumber,
    note: payment.note,
    memo: payment.memo,
    name: payment.name,
    company: payment.company,
    referenceId: payment.referenceId,
    eCheck: payment.eCheck,
    kId: payment.kId,
    status: payment.status,

    checkDate: payment.checkDate ?? new Date().toISOString().split('T')[0],

    // Mapping from nested 'bank' object
    bankId: payment.bank.id,

    // Flattening properties from the nested 'payee' object
    payeeId: payment.payee.id,
    nameOnCheck: payment.payee.nameOnCheck,
    email: payment.payee.email,
    phone: payment.payee.phone,
    address: payment.payee.address,
    city: payment.payee.city,
    state: payment.payee.state,
    zip: payment.payee.zip,
  };
};
